const KNOWN_MOJIBAKE_PLACEHOLDERS = new Set([
  'Р Р†Р вЂљ',
  'Р Р†Р вЂљРІР‚Сњ',
  'Р“СћРІвЂљВ¬РІР‚Сњ',
  'вЂ”',
])

export const EMPTY_VALUE = '—'
export const UNCATEGORIZED_LABEL = 'Uncategorized'

function normalizeString(value) {
  return typeof value === 'string' ? value.trim() : ''
}

export function isMojibakePlaceholder(value) {
  const normalized = normalizeString(value)
  if (!normalized) return false
  if (KNOWN_MOJIBAKE_PLACEHOLDERS.has(normalized)) return true
  return normalized.includes('Р') || normalized.includes('вЂ') || normalized.includes('Сњ')
}

export function formatEmptyValue(value) {
  if (value == null) return EMPTY_VALUE
  if (typeof value === 'string') {
    const normalized = value.trim()
    if (!normalized || isMojibakePlaceholder(normalized)) return EMPTY_VALUE
    return normalized
  }
  return String(value)
}

function parseConfidence(value) {
  if (value == null || value === '') return null
  const parsed = Number(value)
  if (!Number.isFinite(parsed) || parsed < 0) return null
  if (parsed <= 1) return parsed
  if (parsed <= 100) return parsed / 100
  return null
}

export function formatConfidence(value) {
  if (isMojibakePlaceholder(value)) return EMPTY_VALUE
  const normalized = parseConfidence(value)
  if (normalized == null) return EMPTY_VALUE
  return `${Math.round(normalized * 100)}%`
}

export function formatCategoryName(value) {
  if (value == null) return UNCATEGORIZED_LABEL
  const normalized = normalizeString(value)
  if (!normalized || isMojibakePlaceholder(normalized)) return UNCATEGORIZED_LABEL
  return normalized
}
